var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReinzLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 85,
    viewBox: "0 0 179 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.0909 25.1818H103.545L112.818 41.909C113.182 42.6363 113.727 43.5454 114.091 44.2727C114.273 44.6363 114.636 45.909 114.818 46.0908H115L114.818 42.4545C114.636 40.0909 114.636 39.7272 114.636 38.4545V25.1818H121.909V60.8181H115.545L106.091 43.5454C105.364 42.0909 105.182 41.909 103.364 37.7272H103.182C103.182 38.8181 103.364 43.3636 103.364 44.2727V60.9999H96.0909V25.1818Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.091 25.1818H149.909V31.5454L134.636 54.2727H149.909V60.8181H125V54.4545L140.636 31.7272H126.091V25.1818Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4545 40.4545C40.8182 40.4545 41.5455 40.4545 42.6364 40.0909C45.1818 39.1818 45.3636 37.3636 45.3636 35.3636C45.3636 32.8182 44.6364 31.7273 43 31C41.7273 30.6364 40.8182 30.6364 36.4545 30.6364V40.4545ZM36.4545 60.8182H29V25H40.2727C46.0909 25 53.3636 25.7273 53.3636 35.3636C53.3636 39.9091 51.5455 43.3636 46.4545 44.8182L54.2727 60.6364H45.7273L39 46.0909H36.4545V60.8182Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0909 25H78.4546V31.5455H63.9091V39.1818H74.8182V45.7273H63.9091V54.2727H78.2728V60.8182H56.0909V25Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4545 60.8182V28.2727H81.1818V25H92.2727V60.8182H84.4545Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReinzLogo);
export default __webpack_public_path__ + "static/media/reinzLogo.8e0127eb5a0bca1d444798b4183d0915.svg";
export { ForwardRef as ReactComponent };